import { useEffect, useState } from "react";
import { ShoppingBag, MapPin, Flame, Shield } from "lucide-react";
import axios from "axios";
import { useCart } from "@/context/CartContext";
import { API, BACKEND_URL } from "@/lib/format";

export default function Header() {
  const { count, setIsOpen } = useCart();
  const [cfg, setCfg] = useState({ logoUrl: null, nombreLocal: "" });

  useEffect(() => {
    axios.get(`${API}/config`).then((r) => setCfg(r.data)).catch(() => {});
  }, []);

  const logoSrc = cfg.logoUrl ? (cfg.logoUrl.startsWith("/") ? `${BACKEND_URL}${cfg.logoUrl}` : cfg.logoUrl) : null;

  return (
    <header
      data-testid="header-navbar"
      className="sticky top-0 z-40 backdrop-blur-xl bg-ink/90 border-b border-line"
    >
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a href="/" className="flex items-center gap-2 group">
          {logoSrc ? (
            <img src={logoSrc} alt="logo" data-testid="store-logo" className="w-9 h-9 object-contain rounded" />
          ) : (
            <div data-testid="store-logo" className="relative w-9 h-9 rounded-md bg-brand flex items-center justify-center rotate-[-6deg] group-hover:rotate-0 transition-transform duration-300">
              <Flame className="w-5 h-5 text-black" strokeWidth={3} />
            </div>
          )}
        </a>

        {cfg.direccionLocal && (
          <div className="absolute left-1/2 -translate-x-1/2 hidden md:flex items-center gap-2 text-xs uppercase tracking-widest text-zinc-400">
            <MapPin className="w-4 h-4 text-gold" />
            {cfg.direccionLocal}
          </div>
        )}

        <div className="flex items-center gap-2">
          <a href="/admin/login" data-testid="admin-link" className="hidden sm:flex items-center gap-1 text-zinc-600 hover:text-white text-xs uppercase tracking-widest px-2 py-2 transition-colors">
            <Shield className="w-3.5 h-3.5" />
          </a>
          <button
            data-testid="header-cart-button"
            onClick={() => setIsOpen(true)}
            className="relative flex items-center gap-2 bg-brand hover:bg-brand-strong text-black font-black uppercase text-sm px-4 py-2 rounded-md transition-colors duration-200"
          >
            <ShoppingBag className="w-4 h-4" strokeWidth={3} />
            <span className="hidden sm:inline">Carrito</span>
            {count > 0 && (
              <span
                data-testid="cart-badge-count"
                className="pop-in absolute -top-2 -right-2 min-w-[22px] h-[22px] px-1 rounded-full bg-gold text-black text-[11px] font-black flex items-center justify-center border-2 border-ink"
              >
                {count}
              </span>
            )}
          </button>
        </div>
      </div>

      {cfg.direccionLocal && (
        <div
          data-testid="header-address-mobile"
          className="md:hidden flex items-center justify-center gap-1.5 py-1.5 text-[10px] uppercase tracking-widest text-zinc-400 border-t border-line"
        >
          <MapPin className="w-3 h-3 text-gold" />
          {cfg.direccionLocal}
        </div>
      )}
    </header>
  );
}
